import React from "react";

import Price from "../../../../../../common/Price";
import withQuoteData from "../../../../../../hocs/withQuoteData";
import universalTableStockIdExtractor from "../../../../../../lib/UniversalTable/universalTableStockIdExtractor";
import { isNumber } from "lodash/lang";

const PriceFromFirebase = ({
  quoteData,
  resultMetaData: { currency },
  value
}) => {
  const price = quoteData?.close
    ? quoteData?.close
    : isNumber(value)
    ? value
    : null;

  if (!price) {
    return null;
  }

  return (
    <div className="current-price-from-firebase">
      <Price
        value={price}
        currency={currency || ""}
        useCommaAsDecimalPointer
        maxDecimalPlace={6}
      />
    </div>
  );
};

export default withQuoteData(
  false,
  universalTableStockIdExtractor
)(PriceFromFirebase);
